import { createApiSlice } from 'app/createApiSlice'
import { API_GENERIC_DATA_INSURANCE } from 'utils/apiList'

export const detailFarmersApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'farmers/detail',

  endpoints(builder) {
    return {
      fetchGenericDataInsurance: builder.query({
        query(args) {
          const userId = typeof args === 'object' ? args?.userId : args
          return {
            url: API_GENERIC_DATA_INSURANCE,
            params: {
              userId,
            },
          }
        },
      }),
      uploadFile: builder.mutation({
        query({ url, userId, source, description }) {
          return {
            url: `/api/v1/bussines/upload-multimedia`,
            method: 'POST',
            body: {
              url,
              userId,
              source,
              description,
            },
          }
        },
      }),
      editDescription: builder.mutation({
        query({ description, userId }) {
          return {
            url: `api/v1/bussines/group/post-description/${userId}`,
            method: 'POST',
            body: {
              description,
            },
          }
        },
      }),
      deleteMultimedia: builder.mutation({
        query({ id }) {
          return {
            url: `api/v1/bussines/upload-multimedia/${id}`,
            method: 'DELETE',
          }
        },
      }),
    }
  },
})

export const {
  useFetchGenericDataInsuranceQuery,
  useLazyFetchGenericDataInsuranceQuery,
  useUploadFileMutation,
  useEditDescriptionMutation,
  useDeleteMultimediaMutation,
} = detailFarmersApiSlice
